<template>
  <div class="damages-list">
    <v-row>
      <v-col v-for="damage in damagesList" :key='damage.key' cols="12" md="4" lg="4" sm="4">
        <div class="damage-item"
             :class="damage.checked ? 'selected' : ''"
             @click="damage.checked = !damage.checked"
        >
          <div v-if="damage.description !== false">
            <div v-if="isMobile">
              <v-btn class="mx-2 damage-desc" fab dark x-small color="#e2e9fb" @click.stop="damage.infoDialog = true">
                <v-icon color="#456ddd">mdi-help</v-icon>
              </v-btn>
              <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="damage.infoDialog">
                <v-card>
                  <v-card-title class="display-1">{{ damage.name }}</v-card-title>
                  <v-card-text class="headline black--text" >
                    <v-row>
                      <v-col><p>{{ damage.description }}</p></v-col>
                    </v-row>
                    <v-row>
                      <v-col><v-btn @click="damage.infoDialog = false" color="primary">Закрыть</v-btn></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn class="mx-2 damage-desc" fab dark x-small color="#e2e9fb">
                <v-tooltip top max-width="700px" content-class="tooltip-wrapper">
                  <template v-slot:activator="{ on }">
                    <v-icon color="#456ddd" v-on="on" @click.stop="'return false'" >mdi-help</v-icon>
                  </template>
                  <span v-html="damage.description"></span>
                </v-tooltip>
              </v-btn>
            </div>
          </div>
          <span :class='damage.checked ? damage.icons.hover : damage.icons.default' class="hp-icon" ></span>
          <p class="subtitle-1">{{ damage.name }}</p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="start">
        <v-btn color="primary" @click="goNext">Применить</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'TargetOrganDamages',
  data: function () {
    return {
      damagesList: [
        {
          key: 1,
          name: 'Пульсовое давление (для пожилых)',
          icons: {
            default: 'hp-icon-pulse_01',
            hover: 'hp-icon-pulse_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 1}).length > 0 ? true : false,
          description: '> 60 мм рт.ст.',
          infoDialog: false
        },
        {
          key: 2,
          name: 'Электрокардиографические признаки ГЛЖ',
          icons: {
            default: 'hp-icon-ecg-lvh_01',
            hover: 'hp-icon-ecg-lvh_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 2}).length > 0 ? true : false,
          description: 'Индекс Соколова-Лайона SV1+RV5-6>35 мм;<br>Корнельский показатель (RAVL+SV3) для мужчин ≥ 28 мм; для женщин ≥ 20 мм, (RAVL+SV3),<br>' +
              'Корнельское произведение (RAVL+SV3) мм х QRS мс > 2440 мм х мс',
          infoDialog: false
        },
        {
          key: 3,
          name: 'Эхокардиографические признаки ГЛЖ',
          icons: {
            default: 'hp-icon-echo-lvh_01',
            hover: 'hp-icon-echo-lvh_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 3}).length > 0 ? true : false,
          description: 'Индекс ММЛЖ:<br> у мужчин - более 115 г/м2,<br> у женщин - более 95 г/м2 (площадь поверхности тела)',
          infoDialog: false
        },
        {
          key: 4,
          name: 'Утолщение стенки сонных артерий',
          icons: {
            default: 'hp-icon-wall-thick_01',
            hover: 'hp-icon-wall-thick_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 4}).length > 0 ? true : false,
          description: 'Комплекс интима-медиа ≥ 0,9 мм) или бляшка в брахиоцефальных/почечных/подвздошно-бедренных артериях',
          infoDialog: false
        },
        {
          key: 5,
          name: 'Скорость пульсовой волны',
          icons: {
            default: 'hp-icon-pulse-wave_01',
            hover: 'hp-icon-pulse-wave_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 5}).length > 0 ? true : false,
          description: 'Скорость пульсовой волны («каротидно-феморальной») более 10 м/сек',
          infoDialog: false
        },
        {
          key: 6,
          name: 'Хроническая болезнь почек',
          icons: {
            default: 'hp-icon-kidney_01',
            hover: 'hp-icon-kidney_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 6}).length > 0 ? true : false,
          description: '3 стадии (формула CKD-EPI)',
          infoDialog: false
        },
        {
          key: 7,
          name: 'Лодыжечно-плечевой индекс систолического давления',
          icons: {
            default: 'hp-icon-systolic_01',
            hover: 'hp-icon-systolic_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 7}).length > 0 ? true : false,
          description: 'Менее 0,9',
          infoDialog: false
        },
        {
          key: 8,
          name: 'Микроальбуминурия',
          icons: {
            default: 'hp-icon-mau_01',
            hover: 'hp-icon-mau_02'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 8}).length > 0 ? true : false,
          description: '30–300 мг/л',
          infoDialog: false
        },
        {
          key: 9,
          name: 'Сахарный диабет',
          icons: {
            default: 'hp-icon-diabetes_01',
            hover: 'hp-icon-diabetes_01'
          },
          // checked: false,
          checked: this.$store.getters.targetOrganDamages.filter(function (elem) {return elem.key == 9}).length > 0 ? true : false,
          description: false,
          infoDialog: false
        },
      ],
    }
  },
  methods: {
      goNext: function () {
        let checkedDamages = this.damagesList.filter(function (elem) { return elem.checked == true; })
        this.$emit('targetOrganDamagesAreSet', checkedDamages)
      }
  },
  computed: {
    isMobile: function () {
      return screen.width < 600
    },
  },
  created() {
      // this.isMobile = screen.width < 600
  }
}
</script>

<style scoped lang="scss">
  .damages-list {
    padding: 5px;
  }
  .damage-item {
    cursor: pointer;
    transition: background 0.7s ease;
    text-align: center;
    padding: 7px 0px;
    border-radius: 5px;
    box-sizing: border-box;
    position: relative;
    background: rgba(0,0,0,0.03);
    overflow-wrap: break-word;
    .damage-desc {
      position: absolute;
      top: 0px;
      right: -8px;
      width: 25px;
      height: 25px;
      &:hover:before {
        color: red;
      }
    }
    .hp-icon {
      font-size: 3rem;
      color: #858585;
    }
    &.selected {
      box-shadow: 0px 0px 4px 1px rgba(69, 109, 221, 0.4);
      .hp-icon {
        color: #456ddd
      }
    }
    &:hover {
      background: rgba(0,0,0,0.07);
      /*border: 1px dashed #456ddd;*/
      .hp-icon {
        color: #456ddd;
      }
    }
  }
</style>
